import type { CommunityDetail, Privacy } from 'models';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { Avatar, Card, Col, Row, Space, TagList, Text, Title } from 'ui';
import { images } from 'common/utils';

type P = {
  community: CommunityDetail;
};

const getTranslateKey = (key: Privacy) => {
  switch (key) {
    case 'private':
      return 'Private';
    case 'public':
      return 'Public';
    case 'secret':
      return 'Secret';
  }
};

const About = ({ community }: P) => {
  const { t } = useTranslation();

  const { canSeeTags } = usePermissions();

  return (
    <Card className="community-content-about" title="About">
      <Row>
        <Col span={24}>
          <Title level={5} marginBottom>
            Organization
          </Title>
        </Col>
        <Col span={24}>
          <Row align="middle" className="community-content-about__organization">
            <Col className="community-content-about__organization__avatar">
              <Avatar
                alt={t('Organization logo')}
                fallbackPhoto={images.default.organizationProfilePhoto}
                size="lg"
                src={community.organization.profilePhoto}
              />
            </Col>
            <Col>
              <Text strong type="secondary">
                {community.organization.name}
              </Text>
            </Col>
          </Row>
        </Col>
        <Space orientation="vertical" size="large">
          <Col span={24}>
            <Title level={5} marginBottom>
              Privacy
            </Title>
            <TagList tags={[{ name: t(getTranslateKey(community.privacy)) }]} />
          </Col>
          {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases */}
          {community.tags && community.tags.length > 0 && canSeeTags({ organizationId: community.organization.id }) ? (
            <Col span={24}>
              <Title level={5} marginBottom>
                Tags
              </Title>
              <TagList tags={community.tags} />
            </Col>
          ) : null}
        </Space>
      </Row>
    </Card>
  );
};

export default About;
